__webpack_require__.p = "//jumpedfox.github.io/diamondY/";